<template>
  <!-- <l-map
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    style="height: 80%"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate"
  ></l-map>-->
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"/>
    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mapa de comercios</b-card-header>
      <b-card-body>
        <CommerceMap />
      </b-card-body>
    </b-card>
  </div>
</template>

<style>
#map-container {
  width: auto;
  height: 750px;
  margin-top: 0px;
}

.geosearch input::placeholder {
  color: rgb(73, 80, 87) !important;
  opacity: 1; /* Firefox */
}

.geosearch input:-ms-input-placeholder { /* Internet Explorer 10-11 */
 color: rgb(73, 80, 87) !important;
}

.geosearch input::-ms-input-placeholder { /* Microsoft Edge */
 color: rgb(73, 80, 87) !important;
}


.leaflet-touch .leaflet-bar a {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

.leaflet-touch .leaflet-control-zoom-in, .leaflet-touch .leaflet-control-zoom-out {
    font-size: 20px;
}

</style>

<script>
import CommerceMap from "@/components/CommerceMap";

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  name: "MyAwesomeMap",
  components: {
    CommerceMap
  },
  data() {
    return {};
  }
};
</script>